import { ASSET_TYPE } from '@funnels/constants';

export const ORDERED_CATEGORY_TYPES = [
  ASSET_TYPE.PROPERTY,
  ASSET_TYPE.VEHICLE,
  ASSET_TYPE.SAVING_CHECK_ACCOUNT,
  ASSET_TYPE.SUPERANNUATION,
  ASSET_TYPE.SHARES,
  ASSET_TYPE.TERM_DEPOSIT,
  ASSET_TYPE.MANAGED_FUNDS,
  ASSET_TYPE.GIFTS,
  ASSET_TYPE.OTHER_ASSET,
  ASSET_TYPE.HOME_CONTENTS,
];

export const ENTITY_TO_URL_SLUG: { [key: string]: string } = {
  [ASSET_TYPE.PROPERTY]: 'other-property',
  [ASSET_TYPE.VEHICLE]: 'vehicle',
  [ASSET_TYPE.SAVING_CHECK_ACCOUNT]: 'accounts',
  [ASSET_TYPE.SUPERANNUATION]: 'superannuation',
  [ASSET_TYPE.HOME_CONTENTS]: 'home-contents',
};
